import React from 'react';
import { ServiceFee } from '@/lib/TicketApi';
import { displayFee } from '@/lib/displayFee';

interface FeesProps {
  serviceFees?: { items: ServiceFee[] };
  locale?: string;
  className?: string;
}

export const Fees: React.FC<FeesProps> = ({ serviceFees, locale = 'en', className }) => {
  if (!serviceFees || !serviceFees.items || serviceFees.items.length === 0) return null;
  return (
    <span className={className || ''}>
      {serviceFees.items.map((fee, idx) => (
        <span key={fee.name + idx}>
          {displayFee(fee, locale, ' + ', ' ' +fee.name)}{idx < serviceFees.items.length - 1 ? ' ' : ''}
        </span>
      ))}
    </span>
  );
}; 